"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _r10SourceLibrary = require("r10-source-library");
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const OnlineDiscountPill = _styledComponents.default.div`
  display: flex;
  align-items: center;
  background-color: #42e8b4;
  padding: 4px;
  width: max-content;
  color: #000000;
  border-radius: 3px;
  height: 24px;
`;
const DiscountPill = _ref => {
  let {
    text,
    testId = null
  } = _ref;
  return text && /*#__PURE__*/_react.default.createElement(OnlineDiscountPill, {
    "data-test-id": testId
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
    noMargin: true,
    justify: "center",
    size: 1,
    weight: 2
  }, text));
};
var _default = DiscountPill;
exports.default = _default;